import * as ActionTypes from '../actionTypes';

export const toggleTheme = themeMode => {
  // Save theme to localStorage immediately
  localStorage.setItem('themeMode', themeMode);
  
  return {
    type: ActionTypes.TOGGLE_THEME,
    themeMode
  };
};